import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	// Verifica si el estado de autenticación está guardado en el localStorage
	const [isAuthenticated, setIsAuthenticated] = useState(() => {
		const savedAuth = localStorage.getItem("isAuthenticated");
		return savedAuth === "true"; // Si está guardado como "true", el usuario está autenticado
	});

	const login = () => {
		setIsAuthenticated(true);
		localStorage.setItem("isAuthenticated", "true"); // Guarda el estado en localStorage
	};

	const logout = () => {
		setIsAuthenticated(false);
		localStorage.removeItem("isAuthenticated"); // Elimina el estado de autenticación
	};

	useEffect(() => {
		// Asegura que el estado de autenticación se actualice al cargar el componente
		const savedAuth = localStorage.getItem("isAuthenticated");
		if (savedAuth === "true") {
			setIsAuthenticated(true);
		}
	}, []);

	return (
		<AuthContext.Provider value={{ isAuthenticated, login, logout }}>
			{children}
		</AuthContext.Provider>
	);
};
